export enum MicrositeListType {
    All = 0,
    PendingPatient = 1,
    PendingConfirmation = 2,
    PendingCenter = 3,
    PendingNkr = 4,
    ActiveStarterSites = 5,
    ActiveCustomSites = 6,
    Disapproved = 7,
    Inactive = 8,
    Stagnant = 14,
    PendingCards = 9,
    CoachWaitList = 10,
    PostTransplantSites = 11,
    PendingCoach = 12,
    CoachView = 13
}